module.exports = __webpack_public_path__ + "img/Notes-01-512.a04dad08.svg";